import type { UserResponse } from '@/model/user/dto.generated';
import { isInternalTeramotEmail } from '@/model/user/user.model';
import type { AuthStatus, UserDataState } from '@/viewmodel/features/user/state/userTypes';
import { type PayloadAction, createSlice } from '@reduxjs/toolkit';

export const initialState: UserDataState = {
  data: null,
  apiToken: null,
  status: 'idle',
};

const userSlice = createSlice({
  name: 'userData',
  initialState,
  reducers: {
    setUser: (state, action: PayloadAction<UserResponse | null>) => {
      state.data = action.payload;
    },
    setApiToken: (state, action: PayloadAction<string | null>) => {
      state.apiToken = action.payload;
    },
    setStatus: (state, action: PayloadAction<AuthStatus>) => {
      state.status = action.payload;
    },
    logOut: () => initialState,
    signedOut: () => initialState,
  },
});

export const { setUser, setApiToken, setStatus, logOut, signedOut } = userSlice.actions;
export default userSlice.reducer;

type UserState = { userData: UserDataState };

export const selectUserData = (state: UserState) => state.userData;
export const selectApiToken = (state: UserState) => state.userData.apiToken;
export const selectIsLoading = (state: UserState) => state.userData.status === 'loading';
export const selectIsError = (state: UserState) => state.userData.status === 'error';
export const selectIsLoaded = (state: UserState) =>
  state.userData.status === 'ready' || state.userData.status === 'not_found';
export const selectUserNotExistInDB = (state: UserState) => state.userData.status === 'not_found';
export const selectIsInternalUser = (state: UserState) =>
  isInternalTeramotEmail(state.userData.data?.email);
